module.exports = __webpack_public_path__ + "img/city-of-dreams.67bf9327.jpg";